import React from "react";

export function FormText({ children }) {
  return <p style={{ fontSize: 15, marginBottom: 10 }}>{children}</p>;
}
